import { useMemo } from 'react';
import { DefaultLocale, useLocalizationConfig } from './localizationHooks';
import { useUserInfo } from '../user/userApi';

export function useLocalization() {
  const userInfo = useUserInfo();
  const localizationConfig = useLocalizationConfig();

  const localization = useMemo(() => {
    const region = localizationConfig.region;
    const locale = localizationConfig.locale === 'test' ? DefaultLocale : localizationConfig.locale;

    return {
      region,
      locale,
      formats: localizationConfig,
      convertTimeFormat(format) {
        if (localizationConfig.supportCustomTimeFormat !== undefined) {
          if (localizationConfig.timeFormat === '24H') {
            return format
              .replace(/h{1,2}/, 'HH')
              .replace(/\s*[Aa]/, '')
              .trim();
          } else {
            return format.includes('HH') || format.includes('H')
              ? format.replace(/H{1,2}/, 'hh') + ' A'
              : format;
          }
        } else {
          return format;
        }
      }
    };
  }, [userInfo, localizationConfig]);

  return localization;
}
